// services/TeacherProfileService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getTeacherProfiles(params = {}) {
    return api.get(ENDPOINTS.TEACHER_PROFILES.BASE, { params });
}
export function getTeacherProfileById(id) {
    return api.get(ENDPOINTS.TEACHER_PROFILES.BY_ID(id));
}
export function createTeacherProfile(payload) {
    return api.post(ENDPOINTS.TEACHER_PROFILES.BASE, payload);
}
export function updateTeacherProfile(id, payload) {
    return api.patch(ENDPOINTS.TEACHER_PROFILES.BY_ID(id), payload);
}
export function deleteTeacherProfile(id) {
    return api.delete(ENDPOINTS.TEACHER_PROFILES.BY_ID(id));
}
// Matières assignées ("un enseignant peut avoir uniquement ses propres matières").
export function getTeacherSubjects(id) {
    return api.get(`${ENDPOINTS.TEACHER_PROFILES.BY_ID(id)}/subjects`);
}
export function assignTeacherSubject(id, subjectId) {
    return api.post(`${ENDPOINTS.TEACHER_PROFILES.BY_ID(id)}/subjects`, { subject_id: subjectId });
}
export function unassignTeacherSubject(id, subjectId) {
    return api.delete(`${ENDPOINTS.TEACHER_PROFILES.BY_ID(id)}/subjects/${subjectId}`);
}
